import { defaultStoreExtensions } from '@affine/core/blocksuite/manager/store';
import {
  WorkspaceBase,
  type WorkspaceOptions,
} from '@streamlain/workspace-editor/workspace/workspace-base';

import type { FeatureFlagService } from '../../feature-flag';

export type WorkspaceImplOptions = WorkspaceOptions & {
  featureFlagService?: FeatureFlagService;
};

export class WorkspaceImpl extends WorkspaceBase {
  constructor({ featureFlagService, ...options }: WorkspaceImplOptions) {
    super(options, () => defaultStoreExtensions(featureFlagService));
  }
}
